import { PropertyColumns } from '@miq/catalog';

export const companyFields = [
  'usages/company_contact_role_addresses/company_name',
  'usages/company_contact_role_addresses/colloquial/alternative_company_name',
  'usages/company_contact_role_addresses/role_desc',
  'usages/company_contact_role_addresses/company_id',
];

export const MINMAX_MEASUREMENTFIELDSOBJ = {
  MAX_MEASUREMENT: 'property_measurement/property_measurement_size_max',
  MIN_MEASUREMENT: 'property_measurement/property_measurement_size_min',
};

export const MINMAX_MEASUREMENTFIELDS = [
  MINMAX_MEASUREMENTFIELDSOBJ.MAX_MEASUREMENT,
  MINMAX_MEASUREMENTFIELDSOBJ.MIN_MEASUREMENT,
];

export const MAX_MEASUREMENNTOBJ = {
  field: MINMAX_MEASUREMENTFIELDSOBJ.MAX_MEASUREMENT,
  header: 'Property Measurement Size',
  columnId: PropertyColumns.PropertyMeasurements_Max,
  options: { sortable: false },
  inputType: 'text',
  dataType: 'text',
};
